module.exports = __webpack_public_path__ + "static/media/cuisine.9c9792b7.jpg";